module.exports = __webpack_public_path__ + "static/img/dtg-example.219ec8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/dtg-example.png
// module id = ONsk
// module chunks = 1